import _extends from "@babel/runtime/helpers/extends";
import { RecommendationLabel } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { Box, Loader } from '@wix/design-system';
import React, { useState } from 'react';
import { PricingSection } from '../Pricing/PricingSection';
import { SearchRecommendationModule } from './SearchRecommendation.module';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
import { PremiumDomainBadge } from '../PremiumDomainBadge/PremiumDomainBadge';
import { parseDomain } from '@wix/domains-serverless-interface';
import s from './SearchRecommendation.module.scss';
import { AiInsightsButton } from '../Insight/AiInsightsButton';
import { MobileAwareDisabledExplainer } from '../MobileAwareDisabledExplainer';
const SCALED_TITLE_MIN_FONT_SIZE = '0.75rem';
const SCALED_TITLE_MIN_FONT_SIZE_MOBILE = '1rem';
const SCALED_TITLE_MAX_FONT_SIZE = '1.125rem';
export const SearchRecommendation = props => {
  const label = props.label,
    _props$primary = props.primary,
    primary = _props$primary === void 0 ? false : _props$primary,
    _props$primaryBadgeOn = props.primaryBadgeOnly,
    primaryBadgeOnly = _props$primaryBadgeOn === void 0 ? false : _props$primaryBadgeOn,
    _props$active = props.active,
    active = _props$active === void 0 ? false : _props$active,
    domain = props.domain,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$premium = props.premium,
    premium = _props$premium === void 0 ? false : _props$premium,
    price = props.price,
    onButtonClick = props.onButtonClick,
    dataHook = props.dataHook,
    onMouseEnter = props.onMouseEnter,
    impressionReport = props.impressionReport,
    onAiInsightsClick = props.onAiInsightsClick,
    _props$useMobileLayou = props.useMobileLayout,
    useMobileLayout = _props$useMobileLayou === void 0 ? false : _props$useMobileLayou,
    _props$isLeanView = props.isLeanView,
    isLeanView = _props$isLeanView === void 0 ? false : _props$isLeanView,
    _props$useCompactSugg = props.useCompactSuggestionRowStyle,
    useCompactSuggestionRowStyle = _props$useCompactSugg === void 0 ? false : _props$useCompactSugg,
    _props$showLabelBadge = props.showLabelBadge,
    showLabelBadge = _props$showLabelBadge === void 0 ? true : _props$showLabelBadge,
    pricingOptimized = props.pricingOptimized,
    _props$isPricingLoadi = props.isPricingLoading,
    isPricingLoading = _props$isPricingLoadi === void 0 ? false : _props$isPricingLoadi,
    _props$compactPriceLa = props.compactPriceLabel,
    compactPriceLabel = _props$compactPriceLa === void 0 ? false : _props$compactPriceLa,
    _props$titleOverflowS = props.titleOverflowStrategy,
    titleOverflowStrategy = _props$titleOverflowS === void 0 ? 'ellipsis' : _props$titleOverflowS;
  const scalesTitle = titleOverflowStrategy === 'scale';
  const pricingIsOptimized = pricingOptimized ?? (isLeanView || useCompactSuggestionRowStyle);
  const _useState = useState(false),
    isClickLoading = _useState[0],
    setIsClickLoading = _useState[1];
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    t = _DomainSearchSuiteMod.t;
  const _SearchRecommendation = SearchRecommendationModule.SDK.Layouts,
    SearchRecommendationContainer = _SearchRecommendation.SearchRecommendationContainer,
    GetItButtonContainer = _SearchRecommendation.GetItButtonContainer,
    ActionsContainer = _SearchRecommendation.ActionsContainer,
    GetItButton = _SearchRecommendation.GetItButton,
    TitleDisplay = _SearchRecommendation.TitleDisplay,
    LabelContainer = _SearchRecommendation.LabelContainer,
    DomainInfoContainer = _SearchRecommendation.DomainInfoContainer,
    Label = _SearchRecommendation.Label,
    MobileActions = _SearchRecommendation.MobileActions,
    Footer = _SearchRecommendation.Footer,
    InlineExtras = _SearchRecommendation.InlineExtras,
    DomainNote = _SearchRecommendation.DomainNote;
  const hasLabel = label && label !== RecommendationLabel.UNKNOWN_LABEL;
  const showLabel = hasLabel && showLabelBadge;
  const tld = parseDomain(domain ?? '').tld;
  const handleGetItClick = async () => {
    setIsClickLoading(true);
    try {
      await (onButtonClick == null ? void 0 : onButtonClick(props));
    } finally {
      setIsClickLoading(false);
    }
  };
  const getItButton = /*#__PURE__*/React.createElement(MobileAwareDisabledExplainer, {
    disabled: disabled,
    content: t('domain_search_suite.error.domain_manager_permissions.tooltip'),
    tooltipProps: {
      inline: true,
      size: 'medium',
      appendTo: 'scrollParent',
      zIndex: 99999
    }
  }, /*#__PURE__*/React.createElement(GetItButton, {
    disabled: disabled || isClickLoading,
    domainName: domain,
    priority: useCompactSuggestionRowStyle ? 'secondary' : active ? 'primary' : 'secondary',
    className: useCompactSuggestionRowStyle ? s.optimizedGetIt : undefined,
    onClick: handleGetItClick,
    dataHook: `${dataHook}-button`
  }, isClickLoading ? /*#__PURE__*/React.createElement(Loader, {
    size: "tiny"
  }) : t('domain_search_suite.domain_gate.suggestions.card.cta')));
  const labelContainerContent = /*#__PURE__*/React.createElement(LabelContainer, {
    premium: premium,
    visible: showLabel || premium,
    domain: domain ?? '',
    label: label
  }, showLabel && /*#__PURE__*/React.createElement(Label, {
    primary: primary || primaryBadgeOnly,
    label: label,
    domain: domain ?? ''
  }), premium && /*#__PURE__*/React.createElement(PremiumDomainBadge, null));
  const showPrimaryAppearance = primary && !primaryBadgeOnly;
  const isExactMatch = label === RecommendationLabel.EXACT_MATCH;
  const titleDisplay = /*#__PURE__*/React.createElement(TitleDisplay, {
    title: domain ?? '',
    primary: showPrimaryAppearance,
    exactMatch: isExactMatch,
    isLeanView: isLeanView,
    useCompactTitleStyle: useCompactSuggestionRowStyle,
    showComBrRestriction: useCompactSuggestionRowStyle && tld === 'com.br',
    overflowStrategy: titleOverflowStrategy,
    minFontSize: useMobileLayout ? SCALED_TITLE_MIN_FONT_SIZE_MOBILE : SCALED_TITLE_MIN_FONT_SIZE,
    maxFontSize: SCALED_TITLE_MAX_FONT_SIZE
  });
  const impressionRef = DomainSearchSuiteModule.SDK.useSuggestionImpression({
    domain,
    position: (impressionReport == null ? void 0 : impressionReport.position) ?? 0,
    pageNumber: (impressionReport == null ? void 0 : impressionReport.pageNumber) ?? 1,
    isPremium: premium,
    enabled: !!impressionReport
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: impressionRef,
    onMouseEnter: onMouseEnter,
    style: {
      height: '100%',
      ...(useMobileLayout ? {
        width: '100%',
        boxSizing: 'border-box'
      } : {})
    }
  }, /*#__PURE__*/React.createElement(SearchRecommendationContainer, _extends({
    dataHook: dataHook
  }, useMobileLayout ? {
    direction: 'vertical',
    padding: 'SP4',
    gap: 'SP4',
    align: 'left',
    verticalAlign: 'top',
    className: `${s.mobileCard}${showPrimaryAppearance ? ` ${s.mobilePrimaryCard}` : ''}`
  } : useCompactSuggestionRowStyle ? {
    padding: '16px 24px'
  } : {}), useMobileLayout ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: useCompactSuggestionRowStyle ? '8px' : 'SP6',
    wordBreak: scalesTitle ? 'break-word' : undefined,
    width: scalesTitle ? '100%' : undefined
  }, labelContainerContent, /*#__PURE__*/React.createElement(Box, {
    className: scalesTitle ? `${s.mobileDomainTitle} ${s.scaledDomainTitle}` : s.mobileDomainTitle
  }, titleDisplay)), /*#__PURE__*/React.createElement(MobileActions, {
    inline: useCompactSuggestionRowStyle,
    pricing: /*#__PURE__*/React.createElement(PricingSection, {
      pricing: price,
      tld: tld,
      domainName: domain,
      useMobileLayout: true,
      denseStrikethroughStyle: pricingIsOptimized,
      useIntroPriceLabelCopy: compactPriceLabel && pricingIsOptimized,
      matchStrikethroughSize: pricingIsOptimized,
      isPricingLoading: isPricingLoading,
      exactMatch: isExactMatch,
      compactPriceLabel: compactPriceLabel
    }),
    getItButton: getItButton,
    aiInsightsButton: !isLeanView && !useCompactSuggestionRowStyle && onAiInsightsClick ? /*#__PURE__*/React.createElement(AiInsightsButton, {
      onClick: () => onAiInsightsClick(domain ?? '')
    }) : undefined
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    align: "left",
    gap: "SP3",
    flex: scalesTitle ? 1 : undefined,
    minWidth: scalesTitle ? 0 : undefined,
    width: scalesTitle ? '100%' : undefined
  }, /*#__PURE__*/React.createElement(DomainInfoContainer, {
    flex: scalesTitle ? 1 : undefined,
    minWidth: scalesTitle ? 0 : undefined
  }, !useCompactSuggestionRowStyle && labelContainerContent, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    verticalAlign: "middle",
    gap: useCompactSuggestionRowStyle ? 'SP2' : 'SP3'
  }, scalesTitle ? /*#__PURE__*/React.createElement(Box, _extends({}, useCompactSuggestionRowStyle ? {
    verticalAlign: 'middle',
    flexWrap: 'wrap',
    gap: '6px'
  } : {
    display: 'block'
  }, {
    flex: 1,
    minWidth: 0,
    className: s.scaledDomainTitle
  }), titleDisplay, useCompactSuggestionRowStyle && labelContainerContent) : /*#__PURE__*/React.createElement(React.Fragment, null, titleDisplay, useCompactSuggestionRowStyle && labelContainerContent), /*#__PURE__*/React.createElement(InlineExtras, {
    domain: domain,
    active: active
  })), /*#__PURE__*/React.createElement(DomainNote, {
    domain: domain,
    price: price,
    exactMatch: isExactMatch
  }))), /*#__PURE__*/React.createElement(ActionsContainer, {
    flexShrink: scalesTitle ? 0 : undefined
  }, /*#__PURE__*/React.createElement(PricingSection, {
    pricing: price,
    tld: tld,
    domainName: domain,
    denseStrikethroughStyle: pricingIsOptimized,
    useIntroPriceLabelCopy: compactPriceLabel && pricingIsOptimized,
    isPricingLoading: isPricingLoading,
    exactMatch: isExactMatch,
    compactPriceLabel: compactPriceLabel
  }), /*#__PURE__*/React.createElement(GetItButtonContainer, null, getItButton)))), !useMobileLayout && /*#__PURE__*/React.createElement(Footer, {
    domain: domain,
    active: active
  }));
};
//# sourceMappingURL=SearchRecommendation.js.map